import {
    Chart,
    ArcElement,
    DoughnutController,
    Legend,
    Title,
    Tooltip
  } from 'chart.js';

  Chart.register(
    ArcElement,
    DoughnutController,
    Legend,
    Title,
    Tooltip
  );

(function (cash) {
    "use strict";

    if (cash("#location-report-donut-chart").length) {

        let token = document.head.querySelector('meta[name="csrf-token"]');
        fetch('/dashboard/location',{
            method: "GET",
            headers: {
                "X-CSRF-TOKEN": token.content,
                "X-Requested-With" : "XMLHttpRequest"
            }
        })
        .then(response => response.json())
        .then(json => {
            console.log( json )
            cash('#location_count').text(json.total_locations);
            cash('#free_count').text(json.data[0]);
            cash('#one_free_count').text(json.data[1]);
            cash('#two_free_count').text(json.data[2]);
            cash('#multi_free_count').text(json.data[3]);
            cash('#full_count').text(json.data[4]);
            let ctx = cash("#location-report-donut-chart")[0].getContext("2d");
            let myDoughnutChart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: [
                            "Free/Open",
                            "1 open/disponible",
                            "2 open/disponible",
                            "2+ open/disponible",
                            "Full/Remplie"
                        ],
                    datasets: [
                        {
                            data: json.data,
                            backgroundColor: [
                                "#2BB6D0",
                                "#D2DFEA",
                                "#203f90",
                                "#13B176",
                                "#A2AFD5"
                            ],
                            hoverBackgroundColor: [
                                "#2BB6D0",
                                "#D2DFEA",
                                "#203f90",
                                "#13B176",
                                "#A2AFD5"
                            ],
                            borderWidth: 5
                        },
                    ],
                },
                options: {
                    plugins:{
                        legend: {
                            display: false
                                },
                    },
                    cutout: "80%",
                },
            });
        }).catch((error)=>{
            console.log('Could not Fetch Location Report Data');
            console.log(error);
        });


    }

})(cash);
